import DetalhesForm from './DetalhesForm';

const DetalhesTab = () => <DetalhesForm disabled={true} />;

export default DetalhesTab;
